// @ts-strict-ignore
import { useMutation } from '@tanstack/react-query'
import { putReportSchedule } from 'services/TransactionExportService'
import { logSentryError } from 'utils/sentry'

export const usePutReportScheduleMutation = () => {
  return useMutation({
    mutationFn: putReportSchedule,
    onError: error => logSentryError('Error: usePutReportScheduleMutation', error),
  })
}
